export interface NavMenu {
  title: string;
  routeToLoad: string;
  id: string;
}

export enum NavType {
  NONE = "None",
  PROFILE = "Profile",
  DASHBOARD = "Dashboard",
  DOCKET = "Docket",
  DOCUMENT = "Document"
}
